import * as actionTypes from "./actionsTypes";

export const setupdatestatus = (payload) => {
  return {
    type: actionTypes.SETUPDATESTAUS,
    value: payload,
  };
};
